<template>
  <div class="addAndModify">
    <el-container>
      <el-main ref="main" class="tabWrap">
        <el-tabs  v-model="activeName" style="width: 100%">
          <el-tab-pane label="基本信息" name="Tab1" style="height: 700px;overflow-y: auto">
            <el-form class="dataFormBox" :inline="true" :model="dataForm">
              <el-row>
                <el-col :span="12">
                  <el-form-item label-width="150px" label="标题：">
                    <el-input v-model="dataForm.title" placeholder="请输入标题" :readonly="true" clearable></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label-width="150px" label="发文字号：">
                    <el-input v-model="dataForm.documentNum" placeholder="请输入发文字号" :readonly="true" clearable></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="12">
                  <el-form-item label-width="150px" label="发文日期：">
                    <el-date-picker
                        style="width: 100%;"
                        v-model="dataForm.documentDate"
                        :readonly="true"
                        type="date"
                        placeholder="选择日期">
                    </el-date-picker>
                  </el-form-item>
                </el-col>
                <el-col :span="24">
                  <div class="sendList">
                    <el-form-item
                        label="发文部门："
                        label-width="150px"
                        ref="sendListRef"
                    >
                      <div class="el-input tag-wrapper" style="width: 100%;">
                        <el-tag
                            v-for="(tag, index) in dataForm.deptInfo"
                            :key="index"
                            closable
                            style="margin-right: 5px;"
                        >{{ tag.name }}</el-tag
                        >
                      </div>
                    </el-form-item>
                  </div>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="24">
                  <el-form-item label-width="150px" label="附件：">
                    <el-table :data="fileList" border style="width: 100%;">
                      <el-table-column type="index" width="50" label="序号"></el-table-column>
                      <el-table-column
                          v-for="(prop, index) in tableProps"
                          :key="index"
                          :prop="prop.prop"
                          :label="prop.label"
                          :min-width="prop.width"
                      ></el-table-column>
                      <el-table-column label="操作" width="150">
                        <template slot-scope="scope">
                          <el-button
                              size="mini"
                              @click="downloadFile(scope.$index, scope.row)"
                              type="text"
                          >下载附件</el-button>
                            <el-button
                                size="mini"
                                @click="previewFile1(scope.$index, scope.row,'document')"
                                type="text"
                            >预览</el-button>
                        </template>
                      </el-table-column>
                    </el-table>
                  </el-form-item>
                </el-col>
              </el-row>
            </el-form>
          </el-tab-pane>
          <el-tab-pane label="其他信息" name="Tab2" style="height: 700px;overflow-y: auto">
            <el-form class="dataFormBox" :inline="true" :model="dataForm">
              <el-row>
                <el-col :span="12">
                  <el-form-item label-width="120px" label="上传人：">
                    <el-input v-model="dataForm.publishUserName" placeholder="请输入上传人" :readonly="true" clearable></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label-width="120px" label="发布日期：">
                    <el-input v-model="dataForm.publishTime" placeholder="请输入发布日期" :readonly="true" clearable></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
            </el-form>
          </el-tab-pane>
          <el-tab-pane label="权限信息" name="Tab3" style="height: 700px;overflow-y: auto">
            <el-form class="dataFormBox" :inline="true" :model="dataForm">
              <el-row>
                <el-col :span="12">
                  <el-form-item label-width="120px" label="阅读权限：">
                    <el-select v-model="dataForm.permissionList[0].type" placeholder="请选择" disabled>
                      <el-option
                          v-for="item in uploadOptions"
                          :key="item.value"
                          :label="item.label"
                          :value="item.value">
                      </el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label-width="120px" label="下载权限：">
                    <el-select v-model="dataForm.permissionList[1].type" placeholder="请选择" disabled>
                      <el-option
                          v-for="item in uploadOptions"
                          :key="item.value"
                          :label="item.label"
                          :value="item.value">
                      </el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="12">
                  <div v-if="dataForm.permissionList[0].type == '0'" style="height: 10px"></div>
                  <div v-if="dataForm.permissionList[0].type == 1" class="formItem">
                    <el-form-item label-width="120px" label="部门：">
                      <el-tree ref="deptTree1"
                               :data="allDeptList"
                               :props="defaultTreeProps"
                               node-key="id"
                               show-checkbox
                      ></el-tree>
                    </el-form-item>
                  </div>
                  <div v-if="dataForm.permissionList[0].type == 2">
                    <el-form-item label-width="120px" label="岗位：">
                      <el-table
                          ref="dataTable1"
                          :data="jobList"
                          highlight-current-row
                          size="mini"
                          height="100%"
                          border
                      >
                        <el-table-column type="selection" header-align="center"
                                         align="center" width="50"
                                         :selectable="selectable"
                        ></el-table-column>
                        <el-table-column
                            prop="name"
                            label="岗位"
                            :show-overflow-tooltip="true"
                        ></el-table-column>
                      </el-table>
                    </el-form-item>
                  </div>
                </el-col>
                <el-col :span="12">
                  <div v-if="dataForm.permissionList[1].type == 1" class="formItem">
                    <el-form-item label-width="120px" label="部门：">
                      <el-tree ref="deptTree2"
                               :data="allDeptList"
                               :props="defaultTreeProps"
                               node-key="id"
                               show-checkbox
                      ></el-tree>
                    </el-form-item>
                  </div>
                  <div v-if="dataForm.permissionList[1].type == 2">
                    <el-form-item label-width="120px" label="岗位：">
                      <el-table
                          ref="dataTable2"
                          :data="jobList"
                          highlight-current-row
                          size="mini"
                          height="100%"
                          border
                      >
                        <el-table-column type="selection" header-align="center"
                                         align="center" width="50"
                                         :selectable="selectable"
                        ></el-table-column>
                        <el-table-column
                            prop="name"
                            label="岗位"
                            :show-overflow-tooltip="true"
                        ></el-table-column>
                      </el-table>
                    </el-form-item>
                  </div>
                </el-col>
              </el-row>
            </el-form>
          </el-tab-pane>
        </el-tabs>
      </el-main>
      <el-footer class="container">
        <div class="btnMid">
          <el-button type="info" @click="close()">关闭</el-button>
<!--            <el-button type="info" @click="preserve()">保存</el-button>-->
        </div>
      </el-footer>
    </el-container>
  </div>
</template>

<script>
import {
  getPermissionService,
  getRuleDetailService,
  getPermissionCheckService,
  getAllDeptListService,
  getTempUrlService,
} from "@/services/institutionService";
import {exportExcelService2} from "@/services/allContractServices";
import {previewFile} from "@/utils/index.js"
import {getDeptListService, getsubDeptService, manangerStationService} from "@/services/sysSettingService";

export default {
  name: "detail",
  data(){
    return {
      activeName: 'Tab1',
      dataForm: {
        title: '',  //标题
        documentNum: '',  //发文字号
        documentDate: '',  //发文日期
        deptInfo: [],  //发文部门
        permissionList: [
          {
            operateType: 1,
            permissionResourceIdList: 0,
            type: "0"
          },
          {
            operateType: 2,
            permissionResourceIdList: 0,
            type: "0"
          }
        ],
        publishUserName: '',
        publishTime: '',
      },

      uploadOptions: [
        {
          value: 0,
          label: '所有人'
        },
        {
          value: 1,
          label: '按部门'
        },
        {
          value: 2,
          label: '按岗位'
        }
      ],
      allDeptList:[],  //所有部门列表
      defaultTreeProps: {
        id: "id",
        label: "name",
        children: "subDeptList"
      },
      fileList:[],  //文件列表
      tableProps: [
        { prop: "name", label: "文件名称", width: "280px" },
        { prop: "uploadUserName", label: "上传者", width: "140px" },
        { prop: "uploadTime", label: "上传时间", width: "140px" },
      ],
      jobList:[],  //岗位列表
      type:0,  // 1 制度查阅 2制度管理
    }
  },
  methods: {
    onActive(menuCode) {
      this.getJobList();
      this.getAllDeptList();

      if(this.tabRouteParam.id){
        this.dataForm.id = this.tabRouteParam.id;
        this.type = this.tabRouteParam.type;
        this.getRuleDetail();
      }
    },
    //获取详情
    getRuleDetail(){
      let paramsData = {
        systemRuleId: this.dataForm.id
      }
      getRuleDetailService(paramsData).then( res => {
        if(res.code == 10000000){
          this.dataForm =  {
            ...this.dataForm,
            title: res.data.title,  //标题
            documentNum: res.data.documentNum,  //发文字号
            documentDate: res.data.documentDate,  //发文日期
            deptInfo: [{
              name:  res.data.deptName,
              deptId: res.data.deptId,
            }],  //发文部门
            publishUserName: res.data.publishUserName,
            publishTime: res.data.publishTime,
          }
          this.fileList = res.data.attachmentList;
        }else{
          this.$message.error(res.msg);
        }
      }).catch(error => {
        this.$message.error("网络请求失败");
      });
    },
    //获取全部部门列表
    getAllDeptList(){
      getAllDeptListService().then((res) => {
        if (res.code == 10000000) {
          this.allDeptList = res.data;
          this.setDisabled(this.allDeptList)
        } else if (res.code >= 20000000) {
          this.$alert(res.msg, "提示", {
            confirmButtonText: "确定",
          });
        } else {
          this.$alert("系统异常", "提示", {
            confirmButtonText: "确定",
          });
        }
      },(err) => {
        this.$alert(err, "提示", {
          confirmButtonText: "确定",
        });
      });
    },
    //设置禁用
    setDisabled(list){
      list.map(item => {
        item.disabled = true;
        if(item.subDeptList.length != 0){
          this.setDisabled(item.subDeptList)
        }
      })
    },
    //获取岗位下拉列表
    getJobList() {
      let reqParam = {
        orgId: sessionStorage.getItem('orgId'),
        pageIndex: 1,
        pageSize: 10000,
      };
      manangerStationService(reqParam).then(
          (res) => {
            console.log(res);
            if (res.code == 10000000) {
              this.jobList = res.data;
              if(this.tabRouteParam.id){
                this.getPermission();
              }
            } else if (res.code >= 20000000) {
              this.$alert(res.msg, "提示", {
                confirmButtonText: "确定",
              });
            } else {
              this.$alert("系统异常", "提示", {
                confirmButtonText: "确定",
              });
            }
          },
          (err) => {
            console.log("123");
            this.$alert(err, "提示", {
              confirmButtonText: "确定",
            });
          }
      );
    },
    //获取权限
    getPermission(){
      let paramsData = {
        systemRuleId: this.dataForm.id
      }
      getPermissionService(paramsData).then( res => {
        if(res.code == 10000000){
          if(res.data.permissionList.length != 2){
            return
          }
          this.dataForm.permissionList =  res.data.permissionList.sort(this.compare('operateType'));
          this.$nextTick(()=> {
            this.dataForm.permissionList.map((item, index) => {
              if(item.type == 1 ){
                let deptTree = 'deptTree'+ (index + 1);
                this.$refs[deptTree].setCheckedKeys(item.permissionResourceIdList);
                this.$nextTick(()=> {

                })
                setTimeout(()=>{
                  for (var i in this.$refs[deptTree].store.nodesMap) {
                    this.$refs[deptTree].store.nodesMap[i].expanded = true;
                  }
                },1000)
              }else if(item.type == 2){
                let deptTree = 'dataTable'+ (index + 1);
                let arr = [];
                this.jobList.map(jobItem =>{
                  if(item.permissionResourceIdList.findIndex(perItem => perItem == jobItem.id) != -1){
                    arr.push(jobItem)
                  }
                })
                arr.forEach(row => {
                  this.$refs[deptTree].toggleRowSelection(row);
                });
              }
            })
          })
        }else{
          this.$message.error(res.msg);
        }
      }).catch(error => {
        this.$message.error("网络请求失败");
      });
    },
    compare(property){
      return function(a,b){
        let value1 = a[property];
        let value2 = b[property];
        return value1 - value2;
      }
    },
    //文件下载
    downloadFile(index, row) {
      if(this.type == 1 ){
        let paramsData = {
          systemRuleId: this.dataForm.id,
          operateType: 2
        }
        getPermissionCheckService(paramsData).then( res => {
          if(res.code == 10000000){
            if(res.data){
              let reqParam = {
                filePath: row.attachmentItem,
                name: row.name
              };
              this.getTempUrl(reqParam, 1);
            }else {
              this.$message.error(res.msg);
            }
          }else{
            this.$message.error(res.msg);
          }
        }).catch(error => {
          this.$message.error("网络请求失败");
        });
      }else {
        let reqParam = {
          filePath: row.attachmentItem,
          name: row.name
        };
        this.getTempUrl(reqParam, 1);
      }
    },
    getTempUrl(params, type){
      let reqParam = params;
      getTempUrlService(reqParam).then(
              res => {
                if (res.code == 10000000) {
                  if(type == 1){
                    const link = document.createElement('a');
                    // 这里是将链接地址url转成blob地址，
                    fetch(res.data).then(res => res.blob()).then(blob => {
                      link.href = URL.createObjectURL(blob)
                      // 下载文件的名称及文件类型后缀
                      link.download = params.name;
                      document.body.appendChild(link)
                      link.click()
                      //在资源下载完成后 清除 占用的缓存资源
                      window.URL.revokeObjectURL(link.href);
                      document.body.removeChild(link);
                    });
                  }else {
                    let filePath = res.data;
                    let typeLast =
                            filePath.indexOf("?") > 0
                                    ? filePath.indexOf("?")
                                    : filePath.length;
                    let type = filePath.substring(
                            filePath.lastIndexOf(".") + 1,
                            typeLast
                    ); //文件类型
                    if (
                            type.indexOf("doc") != -1 ||
                            type.indexOf("docx") != -1 ||
                            type.indexOf("xsl") != -1 ||
                            type.indexOf("xslx") != -1 ||
                            type.indexOf("xlsx") != -1
                    ) {
                      this.$alert("当前文件类型暂不支持预览", "提示", {
                        confirmButtonText: "确定"
                      });
                    } else if (
                            type.indexOf("pdf") != -1 ||
                            type.indexOf("jpg") != -1 ||
                            type.indexOf("png") != -1 ||
                            type.indexOf("jpeg") != -1
                    ) {
                      // billNoStr.push(res.data);
                      let routeData = this.$router.resolve({
                        path: "/overviewFile",
                        query: { filePath: filePath }
                      });
                      window.open(routeData.href, "_blank");
                    } else {
                      this.$alert("当前文件类型暂不支持预览", "提示", {
                        confirmButtonText: "确定"
                      });
                    }
                  }
                } else {
                  this.$alert(res.msg, "提示", {
                    confirmButtonText: "确定"
                  });
                }
              },
              err => {
                this.$alert("系统异常", "提示", {
                  confirmButtonText: "确定"
                });
              }
      );
    },
        //文件预览
        previewFile1(index, row) {
      if(this.type == 1 ){
        let paramsData = {
          systemRuleId: this.dataForm.id,
          operateType: 2
        }
        getPermissionCheckService(paramsData).then( res => {
          if(res.code == 10000000){
            if(res.data){
              let reqParam = {
                filePath: row.attachmentItem
              };
              previewFile(index, row, 'document');
            }else {
              this.$message.error(res.msg);
            }
          }else{
            this.$message.error(res.msg);
          }
        }).catch(error => {
          this.$message.error("网络请求失败");
        });
      }else {
        let reqParam = {
          filePath: row.attachmentItem
        };
        previewFile(index, row, 'document');
      }
    },
    // 禁止勾选
    selectable(row,index){
      return row.sex==2//为true的时候可以选，为false则不可选择
    },

    // 加载树结点
    loadNode(node, resolve) {
      console.log(node)
      this.node = node;
      this.resolve = resolve;
      // 如果是顶级的父节点
      if (node.level === 0) {
        resolve([{id: Number(sessionStorage.getItem('orgId')), name: sessionStorage.getItem('orgName'), isRootOrg: true}])
      } else if (node.level === 1) {
        // 查找顶级对象
        let reqParam = {
          pid: 0,
          orgId: node.data.id
        };
        getDeptListService(reqParam)
            .then(res => {
              if (res.code == 10000000) {
                let nodes = res.data;
                nodes.forEach(item => {
                  item.leaf = item.isLeaf == 1;
                  item.level = 2;
                });
                return resolve(nodes);
              } else if (res.code >= 20000000) {
                this.$alert(res.msg, "提示", {
                  confirmButtonText: "确定"
                });
              } else {
                this.$message.error(res.Msg);
              }
            })
            .catch(() => {
              let data = [];
              return resolve(data);
            });
      } else {
        // 根据父节点id找寻下一级的所有节点
        let param = {};
        param.deptId = node.data.id;
        getsubDeptService(param)
            .then(res => {
              if (res.code == 10000000) {
                let nodes = res.data;
                nodes.forEach(item => {
                  item.leaf = item.isLeaf == 1;
                  item.level = node.data.level + 1;
                });
                return resolve(nodes);
              } else {
                this.$message.error(res.Msg);
              }
            })
            .catch(() => {
              let data = [];
              return resolve(data);
            });
      }
    },

    close(){
      this.bus.$emit("tabClose", "manageDetails");
      if(this.type == 1 ){
        this.bus.$emit("navMenuChange", {
          routeId: "lookUpIndex"
        });
      }else if(this.type == 2){
        this.bus.$emit("navMenuChange", {
          routeId: "manageIndex"
        });
      }else {
        this.bus.$emit("navMenuChange", {
          routeId: "cancelIndex"
        });
      }
    }
  }
}
</script>

<style scoped lang="scss">
@import "@/assets/css/commonLayout.scss";
.addAndModify {
  height: 100%;
  background-color: white;
  display: flex;
  flex-direction: column;
  .container{
    width: 900px;
  }
}
.tabWrap {
  height: calc(100% - 60px);

  /deep/ .el-tabs--top {
    height: 100%;
    overflow: hidden;

    .el-tabs__content {
      height: calc(100% - 80px);
      padding: 0 20px 20px;
      overflow: auto;

      .el-form-item {
        width: 100%;
      }

      .el-checkbox {
        line-height: 40px;
      }

      .el-textarea {
        min-width: 0px !important;
      }
      .el-cascader {
        width: 100%;
      }

      .el-form-item__content {
        width: calc(100% - 150px);

        .el-input {
          width: 100%;
        }
      }
    }
  }
}
/deep/.el-textarea{
  width: 600px;
}
/deep/.el-tabs__header{
  padding-right: 0 !important;
  .el-tabs__nav-wrap{
    padding-left: 30px;
  }
}
/deep/.el-input.is-disabled .el-input__inner{
  background-color: #fff !important;
  color: #606266 !important;
}
.sendList {
  /deep/.el-form-item{
    width: 100%;
    display: flex;
    .el-form-item__content {
      width: calc(100% - 150px);
      display: flex;
      .el-input {
        flex: 1;
      }
      .el-button {
        margin-left: 10px;
        height: fit-content;
      }
    }
  }

  .tag-wrapper {
    border: 1px solid #dcdfe6;
    padding: 0 5px;
  }
}
.formItem{
  /deep/.el-form-item{
    display: flex;
    align-items: flex-start;
    .el-tree-node__content{
      padding-top: 6px;
    }
  }
}
.btnMid {
  width: 300px;
  margin: 0 auto;
  display: flex;
  justify-content: space-around;
}
</style>
